import * as React from 'react';

import { Icon } from '@rbilabs/components-library/build/components/icon';
import { useIntl } from 'react-intl';

import {
  CreditCardFormInputsWrapper,
  ExpandableContentTitle,
  StyledExpandableContent,
  StyledIconCreditCard,
} from '../styled';

export const AddNewCreditCardWrapper = ({ children }: { children: React.ReactNode }) => {
  const { formatMessage } = useIntl();
  return (
    <StyledExpandableContent
      title={
        <ExpandableContentTitle>
          <StyledIconCreditCard>
            <Icon icon="paymentCard" color="icon-default" width="24px" aria-hidden />
          </StyledIconCreditCard>
          <span>+ {formatMessage({ id: 'addNewCreditCard' })}</span>
        </ExpandableContentTitle>
      }
      content={<CreditCardFormInputsWrapper>{children}</CreditCardFormInputsWrapper>}
    />
  );
};
